import "./styles/application.scss";
import React, { Suspense, useEffect, useState } from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import BalanceOverview from "./pages/BalanceOverview";
import Logs from "./pages/Logs";
import Profile from "./pages/Profile";
import BetsHistory from "./pages/BetsHistory";
import ProfitLoss from "./pages/ProfitLoss";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import CurrentBets from "./pages/CurrentBets/CurrentBets";
import LoginNew from "./Auth2/Login";
import Register from "./Auth2/Registration";
import AccountStatement from "./pages/AccountStatement";
import Otp from "./Auth2/Otp";
import CreatePin from "./Auth2/CreatePin";
import HomeNew from "./pages/HomeNew";
import Deposit from "./pages/Deposit";
import WithDraw from "./pages/WithDraw";
import AfiliateLink from "./pages/AfiliateLink";
import Afiliates from "./pages/Afiliates";
import ReactPlayer from "react-player";
import DepositHistory from "./pages/DepositHistory";
import WithdrawHistory from "./pages/WithdrawHistory";
import Promotions from "./pages/Promotions";
import MyAccount from "./pages/MyAccount";
import ChangePassword from "./Auth2/ChangePassword";
import Refer from "./pages/Refer";
import Casino from "./pages/casino/Casino";
import CasinoIframe from "./components/CasinoIframe";
import Turnover from "./pages/Turnover";
import ForgotPassword from "./Auth2/ForgotPassword";
import InviteFriends from "./pages/InviteFriends";
import RewardCenter from "./pages/RewardCenter";
import Logout from "./pages/Logout";
import ReceivingCenter from "./pages/ReceivingCenter";
import Rescue from "./pages/Rescue";
import PromoCode from "./pages/PromoCode";
import Vip from "./pages/Vip";
import Chat from "./pages/chat/Chat";
import ChatSupport from "./pages/chat/ChatSupport";
import Index from "./CustomerSupport.js/Index";
import SecurityCenter from "./pages/SecurityCenter";
import { ThemeProvider } from "./context/ThemeContext";

import { ProtectedRouteLogin } from "./components/ProctectedRoute";
import HomeSkyWeb from "./pages/Sky/WebSky/Home";
import DetailWebSky from "./pages/Sky/WebSky/Detail";
import Inplay from "./pages/Sky/WebSky/Inplay";
import FavouriteSkyWeb from "./pages/Sky/WebSky/FavouriteSky";
import LeagueVelki from "./pages/Velkie/LeagueVelki";
import SkyIndex from "./pages/Sky/Index";
import InPlay from "./pages/Sky/InPlay";
import DetailSky from "./pages/Sky/MatchDetail/DetailSky";
import FavouriteVelkie from "./pages/Velkie/FavouriteVelkie";
import FavouriteSky from "./pages/Sky/FavouriteSky";
import SportsNew from "./pages/Sky/SportsNew";
import AccountSky from "./pages/Sky/AccountSky";
import AccountWeb from "./pages/Sky/Account/AccountWeb";
import MyBetsWeb from "./pages/Sky/Account/MyBetsWeb";
import Activitylog from "./pages/Sky/Account/Activitylog";
import AccountStatementSky from "./pages/Sky/Account/AccountStatement";
import BalanceOverviewSky from "./pages/Sky/Account/BalanceOverview";
import CurrentBet from "./pages/Velkie/Account/CurrentBet";
import VelkieIndex from "./pages/Velkie/Index";
import Detail from "./pages/Velkie/MatchDetail/Detail";
import { isMobile } from "react-device-detect";
import loaderImg from "./assets/images/loader.webp";
import brandLogo from "./assets/images/logo.png";
import PaymentStatus from "./pages/PaymentStatus";
import ResetPassword from "./pages/ResePassword";
import Notice from "./pages/Notice";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ThemeProvider>
          <AuthProvider>
            <BetSlipProvider>
              <Outlet />
            </BetSlipProvider>
          </AuthProvider>
        </ThemeProvider>
      }
    >
      {" "}
      <Route path="/logout" element={<Logout />} />
      <Route path="/auth" element={<HomeNew />} />
      <Route path="/" element={<HomeNew />} />
      <Route path="/m/home" element={<HomeNew />} />
      <Route path="/m/index.html" element={<HomeNew />} />
      <Route path="/notice" element={<Notice />} />
      <Route path="/m/notice" element={<Notice />} />
      <Route path="/m/promotions" element={<Navigate to="/promotions" replace />} />
      <Route path="/m/activity" element={<Navigate to="/promotions" replace />} />
      <Route path="/m/inviteFriends" element={<Navigate to="/inviteFriends" replace />} />
      <Route path="/m/rewardCenter" element={<Navigate to="/rewardCenter" replace />} />
      <Route path="/m/myAccount" element={<Navigate to="/myaccount" replace />} />
      <Route path="/m/login" element={<Navigate to="/login" replace />} />
      <Route path="/m/register" element={<Navigate to="/register" replace />} />
      <Route path="/m/deposit" element={<Navigate to="/deposit" replace />} />
      <Route path="/m/withdraw" element={<Navigate to="/withdraw" replace />} />
      <Route path="/m/vip" element={<Navigate to="/vip" replace />} />
      <Route path="/m/casino" element={<Navigate to="/casino" replace />} />
      <Route path="/pin" element={<CreatePin />} />
      <Route
        path="/deposit"
        element={
          <ProtectedRouteLogin>
            <Deposit />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/deposit/:offerCode"
        element={
          <ProtectedRouteLogin>
            <Deposit />
          </ProtectedRouteLogin>
        }
        exact
      />
      <Route
        path="/withdraw"
        element={
          <ProtectedRouteLogin>
            <WithDraw />
          </ProtectedRouteLogin>
        }
      />    <Route
        path="/reset-password"
        element={
          <ProtectedRouteLogin>
            <ResetPassword />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/myaccount"
        element={
          <ProtectedRouteLogin>
            <MyAccount />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/login" element={<LoginNew />} />
      <Route path="/register" element={<Register />} />
      <Route path="/otp" element={<Otp />} />
      <Route
        path="/affilate"
        element={
          
            <AfiliateLink />
          
        }
      />
      <Route path="/affilates" element={<Afiliates />} />
      <Route
        path="/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverview />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/current-bets"
        element={
          <ProtectedRouteLogin>
            <CurrentBets />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/active-log"
        element={
          <ProtectedRouteLogin>
            <Logs />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/my-profile"
        element={
          <ProtectedRouteLogin>
            <Profile />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/bets-history"
        element={
          <ProtectedRouteLogin>
            <BetsHistory />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatement />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/profit-and-loss"
        element={
          <ProtectedRouteLogin>
            <ProfitLoss />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/deposit-history"
        element={
          <ProtectedRouteLogin>
            <DepositHistory />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/withdraw-history"
        element={
          <ProtectedRouteLogin>
            <WithdrawHistory />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/refer" element={<Refer />} />
      <Route path="/change-password" element={<ChangePassword />} />
      <Route path="/casino" element={<Casino />} />
      <Route exact path="/CasinoIframe" element={<CasinoIframe />}></Route>
      <Route
        path="/turnover"
        element={
          <ProtectedRouteLogin>
            <Turnover />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/promotions" element={<Promotions />} />
      <Route path="/inviteFriends" element={<InviteFriends />} />
      <Route
        path="/rewardCenter"
        element={
          <ProtectedRouteLogin>
            <RewardCenter />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/receivingCenter"
        element={
          <ProtectedRouteLogin>
            <ReceivingCenter />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/rescue"
        element={
          <ProtectedRouteLogin>
            <Rescue />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/promoCode" element={<PromoCode />} />
      <Route
        path="/vip"
        element={
          <ProtectedRouteLogin>
            <Vip />
          </ProtectedRouteLogin>
        }
      />
      <Route path="/chat" element={<Chat />} />
      <Route path="/chat-support" element={<ChatSupport />} />
      <Route path="/customer-support" element={<Index />} />
      <Route
        path="/securityCenter"
        element={
          <ProtectedRouteLogin>
            <SecurityCenter />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange-velki/current-bet"
        element={
          <ProtectedRouteLogin>
            <CurrentBet />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/profile"
        element={
          <ProtectedRouteLogin>
            <AccountWeb />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/my-bets"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/profit-loss"
        element={
          <ProtectedRouteLogin>
            <MyBetsWeb />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/activity-log"
        element={
          <ProtectedRouteLogin>
            <Activitylog />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/exchange/account-statement"
        element={
          <ProtectedRouteLogin>
            <AccountStatementSky />
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/exchange/balance-overview"
        element={
          <ProtectedRouteLogin>
            <BalanceOverviewSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-velki"
        element={
          <ProtectedRouteLogin>
            <VelkieIndex />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />{" "}
      <Route
        path="/sports-sky/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <SkyIndex /> : <HomeSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/sports-sky-new"
        element={
          <ProtectedRouteLogin>
            <SportsNew />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/account-sky"
        element={
          <ProtectedRouteLogin>
            <AccountSky />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-velkie"
        element={
          <ProtectedRouteLogin>
            <FavouriteVelkie />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/favourite-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <FavouriteSky /> : <FavouriteSkyWeb />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/inplay-sky"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <InPlay /> : <Inplay />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/league-velki"
        element={
          <ProtectedRouteLogin>
            <LeagueVelki />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-sky/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            {isMobile ? <DetailSky /> : <DetailWebSky />}
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route
        path="/match-detail-velki/:eventId/:marketId/:type"
        element={
          <ProtectedRouteLogin>
            <Detail />
          </ProtectedRouteLogin>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
       <Route path="/proceed" element={<PaymentStatus />} />
    </Route>,
  ),
);

const App = () => {
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    setLoader(true);
    let timer;
    clearTimeout(timer);
    timer = setTimeout(() => {
      setLoader(false);
    }, 2000);
  }, []);
  return loader ? (
    <div className="loading-img-container">
      <div className="loading-img-art" style={{ backgroundImage: `url(${loaderImg})` }}>
        <div className="loading-img-brand">
          <img src={brandLogo} alt="CK75.live" />
        </div>
        <div className="loading-img-footer">www.CK75.live</div>
      </div>
    </div>
  ) : (
    <RouterProvider router={router} />
  );
};

export default App;
